module.exports = __webpack_public_path__ + "img/plus-box.a3cc88b0.svg";